import { Leg } from "@dto/Direction";

/**
 * Calculate the duration of legs, and return a format that can be displayed.
 */
const formatDurationForLegs = (legs: Leg[] | undefined) => {
  const durationInSeconds = (legs ?? []).reduce((aggregate: number, item) => {
    return aggregate + item.duration.value;
  }, 0);

  return formatDuration(durationInSeconds);
};

const formatDuration = (durationInSeconds: number) => {
  if (durationInSeconds === 0) {
    return { durationFormatted: "0", unit: "min" };
  }

  if (durationInSeconds < 60) {
    return {
      durationFormatted: `${durationInSeconds}`,
      unit: "sec",
    };
  }

  if (durationInSeconds < 3600) {
    return {
      durationFormatted: `${Math.floor(durationInSeconds / 60)}`,
      unit: "min",
    };
  }

  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);

  return {
    durationFormatted: `${hours}:${minutes.toString().padStart(2, "0")}`,
    unit: "hrs",
  };
};

export { formatDuration, formatDurationForLegs };
